import React from 'react'
import { motion } from 'framer-motion'

const EnhancedCard = ({ children, className = '', onClick, ...props }) => {
    return (
        <motion.div
            whileHover={{ y: -2, boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' }}
            className={`bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm transition-all duration-300 ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </motion.div>
    )
}

export default EnhancedCard
